
import { Event } from '@process-advisor/process-miner/api/events';
import { getEventEmitter } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    props: {
        param: string,
    }
}

export const openLifecycleModalSingle = ({ props }:  Props) => {
    let eventEmitter = getEventEmitter()
    eventEmitter.emit(Event.openLifecycleModalSingle, { props });
};
